/**
 * "May I still write this team calendar?" — asked of the SERVER right before
 * a move into it (card 25e3e5a2).
 *
 * The editor offers team calendars by the CACHED role. If the user was
 * demoted meanwhile, a move went ahead: the old copy's delete synced while
 * the team create was refused, and other devices lost the appointment until
 * the push succeeded (never, if the role is really gone). One fresh
 * `GET /teams` closes that window. Offline, the move proceeds as before —
 * local-first saves cannot wait for a server they cannot reach.
 */
import teamsService from '../../../services/teamsService';
import { calendarTeamId } from './calendarStore';

export const NO_TEAM_WRITE = 'no_team_write';

export async function assertCanWriteCalendar(calendarKey) {
  const teamId = calendarTeamId(calendarKey);
  if (teamId == null) return;
  let rows;
  try {
    const res = await teamsService.getTeams();
    rows = Array.isArray(res) ? res : res?.data;
  } catch {
    return; // unreachable server: keep the local-first behaviour
  }
  const team = (rows || []).find((row) => String(row?.id) === String(teamId));
  const role = team?.role || (team?.is_owner ? 'owner' : null);
  if (!role || role === 'viewer') {
    const err = new Error('You can no longer add appointments to this team calendar.');
    err.code = NO_TEAM_WRITE;
    throw err;
  }
}
